import { AnimatePresence, motion } from "motion/react";
import { ForwardedRef, forwardRef, PropsWithChildren, useEffect } from "react";
import { ReactComponent as ChevronLeftIcon } from "./../../../assets/icons/chevron-left.svg";
import { ReactComponent as CloseIcon } from "./../../../assets/icons/close.svg";
import "./Overlay.scss";

interface IOverlay {
    isVisible?: boolean;
    requestClose?: () => void,
}

function Overlay({ isVisible, requestClose, children }: PropsWithChildren<IOverlay>, ref: ForwardedRef<HTMLDivElement>) {
    useEffect(() => {
        document.body.classList.add('overlay--opened');

        return () => {
            document.body.classList.remove('overlay--opened');
        }
    }, [])
    return (
        <AnimatePresence>
            {isVisible && (
                <motion.div
                    className="overlay"
                    ref={ref}
                    initial={{ x: '-100%' }}
                    animate={{ x: 0 }}
                    exit={{ x: '-100%' }}
                    transition={{ duration: 0.5 }}
                >
                    <div className="overlay__wrapper">
                        <div className="overlay__container">
                            {children}
                        </div>

                        <button type="button" className="overlay__hide" onClick={handleClose}>
                            <ChevronLeftIcon />
                        </button>

                        <button type="button" className="overlay__close" onClick={handleClose}>
                            <CloseIcon />
                        </button>
                    </div>

                    <div className="overlay__mask" />
                </motion.div>
            )}
        </AnimatePresence>
    )

    function handleClose() {
        if (!requestClose) {
            return;
        }
        document.body.classList.remove('overlay--opened');
        return requestClose();
    }
}
export default forwardRef<HTMLDivElement, PropsWithChildren<IOverlay>>(Overlay);
